import {Component, Input, OnInit} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfirmationService, MessageService, SelectItem } from 'primeng/api';
import {ProductoGarantiaIdoneaService} from '../../../_services/producto-garantia-idonea.service';
import {firstValueFrom, forkJoin} from 'rxjs';
import {Producto} from '../../../_models/producto';
import {RolFuncionalitiesServices} from '../../../_services/rol-funcionalidad.service';
import {AutenticacionService} from '../../../_services/autenticacion.service';
import {GarantiasIdoneasModalidadesService} from '../../../_services/garantias-idoneas-modalidades.service';
import {BienDeDerechoTree, OtraGarantiaTree, TipoGarantiaProducto, TipoGarantiaTree} from '../../../_models/tipo-garantia';
import {ProductoGarantiaIdonea} from '../../../_models/producto-garantia-idonea';
import {NavService} from '../../../_services/_nav.service';

@Component({
  selector: 'app-producto-garantia-idonea',
  standalone: false,
  providers: [ConfirmationService, MessageService],
  templateUrl: './producto-garantia-idonea.component.html',
  styleUrl: './producto-garantia-idonea.component.scss'
})
export class ProductoGarantiaIdoneaComponent implements OnInit {
  @Input()producto:Producto;
  @Input()esDetalle = false;
  //controles
  permisos = {agrega: false, editar: false};

  // Formulario de registro (Agregar/Editar)
  registroForm: FormGroup;
  // Formulario de filtros
  filtroForm: FormGroup;

  // Estados visuales
  loading: boolean = false;
  showAddForm: boolean = false;
  submitted: boolean = false;
  editando: boolean = false;
  // Listas para combos
  lisTiposGarantiasTodos : TipoGarantiaTree[] = [];
  lisTiposGarantia: SelectItem[] = [];
  lisClasesGarantiaTodos: OtraGarantiaTree[] = []
  lisClasesGarantia: SelectItem[] = [];
  lisBienesDerechosTodos:BienDeDerechoTree[]=[];
  lisBienesDerechos: SelectItem[] = [];
  lisEstados: SelectItem[] = [];

  // Configuración de tabla
  cols: any[] = [];
  dataGarantias: ProductoGarantiaIdonea[] = [];
  private allDataGarantias: ProductoGarantiaIdonea[] = [];

  constructor(
    private fb: FormBuilder,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private navService: NavService,
    private productoGarantiaIdoneaService : ProductoGarantiaIdoneaService,
    private rolFuncionalidadService: RolFuncionalitiesServices,
    private autServicio: AutenticacionService,
    private garantiasIdoneasModalidadesService : GarantiasIdoneasModalidadesService

  ) {
    this.initForms();
  }

  async ngOnInit() {
    this.initCols();
    this.initPerm();
    this.initLists();
    await this.loadMockData();
    this.setupSearch();
  }

  private setupSearch(): void {
    this.filtroForm.get('buscar').valueChanges.subscribe(value => {
      if (value?.length >= 3 || value?.length === 0) {
        this.onFiltrar();
      }
    });

    this.filtroForm.get('estado').valueChanges.subscribe(() => {
      this.onFiltrar();
    });
  }

  private initForms(): void {
    this.registroForm = this.fb.group({
      tipoGarantia: [null, Validators.required],
      claseGarantia: [null, Validators.required],
      bienDerecho: [null, Validators.required],
      obligatorioDesde: [null, [Validators.required, Validators.pattern('^[0-9]*$')]],
      habilitado: [true]
    });

    this.filtroForm = this.fb.group({
      buscar: [''],
      estado: [null]
    });
  }

  get f() {
    return this.registroForm.controls;
  }


  private initCols(): void {
    this.cols = [
      { field: 'tipoGarantia', header: 'GARANTIAPRODUCTOS.COL_TIPO_GARANTIA' },
      { field: 'otraGarantia', header: 'GARANTIAPRODUCTOS.COL_CLASE_GARANTIA' },
      { field: 'bienDeDerecho', header: 'GARANTIAPRODUCTOS.COL_BIEN_DERECHO' },
      { field: 'pagarePersonaNatural', header: 'GARANTIAPRODUCTOS.COL_PAGARE_PN' },
      { field: 'pagarePersonaJuridica', header: 'GARANTIAPRODUCTOS.COL_PAGARE_PJ' },
      { field: 'endeudamientoSMLV', header: 'GARANTIAPRODUCTOS.COL_ENDEUDAMIENTO_TOTAL' },
      { field: 'obligatorioDesdeSMLV', header: 'GARANTIAPRODUCTOS.COL_OBLIGATORIO_DESDE' },
      { field: 'maximoFinanciar', header: 'GARANTIAPRODUCTOS.COL_MAX_FINANCIAR' },
      { field: 'minimoCompraLeasing', header: 'GARANTIAPRODUCTOS.COL_MIN_OPC_LEASING' },
      { field: 'maximoCompraLeasing', header: 'GARANTIAPRODUCTOS.COL_MAX_OPC_LEASING' },
      { field: 'indicadorHabilitado', header: 'GARANTIAPRODUCTOS.LBL_ESTADO' },
      { field: 'acciones', header: 'GARANTIAPRODUCTOS.LBL_ACCIONES' }
    ];
  }

  private initPerm(): void {
    forkJoin([
      this.rolFuncionalidadService.getByCodigoPadreCodigoHijo('PRODUCTO', 'ADMGRI', 'AGREGA'),
      this.rolFuncionalidadService.getByCodigoPadreCodigoHijo('PRODUCTO', 'ADMGRI', 'EDIGAR'),
    ]).subscribe({
      next: ([agrega, edigar]) => {
        //optiniene los permisos
        this.permisos.agrega = !!agrega.find( x => !!this.autServicio.obtenerRolesUsuarios().find( y => x.codigoRol === y ) && x.indicadorHabilitado );
        this.permisos.editar = !!edigar.find( x => !!this.autServicio.obtenerRolesUsuarios().find( y => x.codigoRol === y ) && x.indicadorHabilitado );
      },
      error: (err) => {
        console.error('Error:', err);
      }
    });

    this.lisEstados = [
      { label: 'Habilitado', value: true },
      { label: 'Inhabilitado', value: false }
    ];
  }

  initLists() {
    this.loading = true;
    forkJoin([
      this.garantiasIdoneasModalidadesService.optenerXModalidad(this.producto.codigoModalidades)
    ]).subscribe({
      next: ([tipoGarantia]) => {
        this.lisTiposGarantiasTodos = tipoGarantia;
        this.lisTiposGarantiasTodos.forEach(x =>{
          if (!this.lisTiposGarantia.find(y => x.idTipoGarantia === y.value)){
            this.lisTiposGarantia.push({label: x.tipoGarantia, value: x.idTipoGarantia});
          }
        })
        this.loading = false;
      },
      error: (err) => {
        console.error('Error:', err);
      }
    });
  }

  llenarLisClasesGarantia() {
    if (!this.f.tipoGarantia.value){return;}
    this.lisClasesGarantia = [];
    this.lisClasesGarantiaTodos = [];
    const tipoGarantia = this.lisTiposGarantiasTodos.find(x => x.idTipoGarantia === this.f.tipoGarantia.value);
    this.lisClasesGarantiaTodos = tipoGarantia?.otras;
    tipoGarantia.otras.forEach(x =>{
      if (!this.lisClasesGarantia.find(y => x.idOtraGarantia === y.value)){
        this.lisClasesGarantia.push({label: x.otraGarantia, value: x.idOtraGarantia});
      }
    })
    if (this.lisClasesGarantia.length === 1 ) {
      this.f.claseGarantia.setValue(this.lisClasesGarantia[0].value);
    }
    this.llenarLisBienesDerechos();
  }

  llenarLisBienesDerechos() {
    if (!this.f.claseGarantia.value){return;}
    this.lisBienesDerechos = [];
    this.lisBienesDerechosTodos = [];
    const claseGarantia = this.lisClasesGarantiaTodos.find(x => x.idOtraGarantia === this.f.claseGarantia.value);
    claseGarantia.bienes.forEach(x => {
      if (!this.lisBienesDerechos.find(y => x.idBienDeDerecho === y.value)){
        this.lisBienesDerechos.push({label:x.bienDeDerecho, value: x.idBienDeDerecho});
      }
    });
    this.lisBienesDerechosTodos = claseGarantia.bienes;
    if (this.lisBienesDerechos.length === 1 ) {
      this.f.bienDerecho.setValue(this.lisBienesDerechos[0].value);
    }
  }

  //llena el listado en general de la tabla
  async loadMockData() {
    this.dataGarantias = await firstValueFrom(this.productoGarantiaIdoneaService.obtenerProductoGarantiaIdoneasModalidades(this.producto.idProducto))
    this.allDataGarantias = [...this.dataGarantias];
  }

  // Acciones
  toggleAddForm(): void {
    this.showAddForm = !this.showAddForm;
    this.resetearCampos();
    if (!this.showAddForm) {
      this.registroForm.reset({ habilitado: true });
    }
  }

  onGuardar(): void {
    this.submitted = true;
    if (this.registroForm.valid) {
      this.loading = true;
      const obj = {} as TipoGarantiaProducto;
      const bien =  this.lisBienesDerechosTodos.find( x => x.idBienDeDerecho === this.f.bienDerecho.value);
      obj.idProducto = this.producto.idProducto;
      obj.idGarantiaIdoneaModalidad = bien.idGarantiaIdoneaModalidad;
      obj.indicadorHabilitado = this.f.habilitado.value;
      obj.obligatorioDesdeSMLV = this.f.obligatorioDesde.value;
      obj.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
      if (!this.editando){
        if (!this.validarExisteConfig()){
          this.loading = false;
          this.submitted = false;
          this.resetearCampos();
          return;
        }
        this.productoGarantiaIdoneaService.crear(obj).subscribe(async r => {
          await this.loadMockData();
          this.messageService.add({
            severity: 'success',
            summary: 'Éxito',
            detail: 'Garantía guardada correctamente'
          });
          this.toggleAddForm();
          this.loading = false;
          this.submitted = false;
          this.editando = false;
          this.resetearCampos();
        },error => {console.log(error)});
      }else {
        this.productoGarantiaIdoneaService.actualizar(obj).subscribe(async r => {
          await this.loadMockData();
          this.messageService.add({
            severity: 'success',
            summary: 'Éxito',
            detail: 'Garantía guardada correctamente'
          });
          this.toggleAddForm();
          this.loading = false;
          this.submitted = false;
          this.editando = false;
          this.resetearCampos()
        },error => {console.log(error)});
      }


    }
  }

  validarExisteConfig(): boolean {
    const existe = this.allDataGarantias.some(x =>
      x.idTipoGarantia === this.f.tipoGarantia.value &&
      x.idOtraGarantia === this.f.claseGarantia.value &&
      x.idBienDeDerecho === this.f.bienDerecho.value
    );

    if (existe) {
      this.navService.setMesage(4, {
        severity: 'error',
        summary: this.navService.buscarMensaje('LBL_ERROR'),
        detail: this.navService.buscarMensaje('Ya se encuentra esta configuración creada')
      });
      return false;
    }else {
      return true;
    }
  }

  onCancelar(): void {
    this.resetearCampos();
    this.toggleAddForm();
  }

  onFiltrar(): void {
    const { buscar, estado } = this.filtroForm.value;
    const searchLower = buscar?.toLowerCase() || '';


    this.dataGarantias = this.allDataGarantias.filter(item => {
      const matchesSearch = !searchLower || Object.values(item).some(val =>
        String(val).toLowerCase().includes(searchLower)
      );

      const matchesStatus = (estado === null || estado === undefined) || item.indicadorHabilitado === estado;

      return matchesSearch && matchesStatus;
    });
  }

  onLimpiar(): void {
    this.filtroForm.reset();
    this.dataGarantias = [...this.allDataGarantias];
  }

  onEditar(row: ProductoGarantiaIdonea): void {
    this.showAddForm = true;
    this.editando = true;
    //setear valores
    this.f.tipoGarantia.setValue(row.idTipoGarantia);
    this.f.claseGarantia.setValue(row.idOtraGarantia);
    this.f.bienDerecho.setValue(row.idBienDeDerecho);
    this.f.obligatorioDesde.setValue(row.obligatorioDesdeSMLV);
    this.f.habilitado.setValue(row.indicadorHabilitado);
    //inhabilitar campos
    this.f.tipoGarantia.disable();
    this.f.claseGarantia.disable();
    this.f.bienDerecho.disable();
    this.llenarLisClasesGarantia();
  }
  resetearCampos(): void {
    this.f.tipoGarantia.setValue(null);
    this.f.claseGarantia.setValue(null);
    this.f.bienDerecho.setValue(null);
    this.f.obligatorioDesde.setValue(null);
    this.f.habilitado.setValue(null);
    //habilitar campos
    this.f.tipoGarantia.enable();
    this.f.claseGarantia.enable();
    this.f.bienDerecho.enable();
    this.f.obligatorioDesde.enable();
    this.f.habilitado.enable();
  }
}

